import React, { useMemo } from 'react';
import styled from 'styled-components';
import moment from 'moment';

import DatePicker from 'antd/es/date-picker';
// import Tooltip from 'antd/es/tooltip';
// import Progress from 'antd/es/progress';
// import Dropdown from 'antd/es/dropdown';
// import Menu from 'antd/es/menu';

import { datePickerFormats } from 'config/common';
// import Spin from 'antd/es/spin';
// import colors from 'config/colors';

import useSearcher from 'hooks/useSearcher';
import useQueryParam from 'hooks/useQueryParam';
import usePersistentDatePicker from 'hooks/usePersistentDatePicker';
// import { useContainerClassSelect, useCustomerSelect, useLocationSelect } from 'hooks/useSelect';

// import useIndividualsStats from 'hooks/useIndividualsStats';
// import useIndividualsGoals from 'hooks/useIndividualsGoals';
import useIndividualsReportStats from 'hooks/useIndividualsReportStats';
import Stats from '../components/Stats';

import MainLayout from 'layouts/Main.layout';

// import useResource from 'hooks/useResource';
// import { ResourceType } from 'services/resources';

import { Row, Col } from 'components/layout';
// import { Text } from 'components/Text';
import PageHeader from 'components/MainPageHeader';
import Table from 'components/Table';
import FilterBar from 'components/FilterBar';
import Search from 'components/Search';
// import Select from 'components/Select';
import PeriodFilter from 'components/PeriodFilter';
// import Button from 'components/Button';
// import Icon from 'components/Icon';

// import { exportIndividualStats } from '../helpers';
// import { TOP_INDIVIDUAL_SORT_OPTIONS } from '../constants';

const IndividualStatsPageHeader = styled(PageHeader)`
  & .ant-page-header-heading-sub-title {
    display: inline-flex;
    justify-content: center;
    flex: 1;
    margin-right: 110px;
  }
`;


const IndividualsStats = () => {
  const datePicker = usePersistentDatePicker({ queryParam: 'dt' });
  // const locationSelect = useLocationSelect();
  // const containerTypeSelect = useContainerClassSelect({
  //   queryParam: 'containerType',
  //   hasAllOption: true,
  //   allOptionKey: '',
  // });
  // const customerSelect = useCustomerSelect({
  //   queryParam: 'customer',
  //   hasAllOption: true,
  //   allOptionKey: '',
  // });
  // const [sortByScore, setSortByScore] = useState(TOP_INDIVIDUAL_SORT_OPTIONS[0].value);
  const [searchVal, setSearchVal] = useQueryParam('s', '');

  const { data: reportStats, isLoading: reportStatsLoading } = useIndividualsReportStats({
    from_dt: datePicker.date
      ? datePicker.date.clone().startOf(datePicker.mode === 'date' ? 'day' : datePicker.mode).format('YYYY-MM-DD')
      : null,
    to_dt: datePicker.date
      ? datePicker.date
          .clone()
          .startOf(datePicker.mode === 'date' ? 'day' : datePicker.mode)
          .add(1, datePicker.mode === 'date' ? 'day' : datePicker.mode)
          .format('YYYY-MM-DD')
      : null,
  });

  const searcher = useSearcher([
    'full_name',
  ]);

  // const customers = useResource(ResourceType.customers);

  // const {
  //   isLoading: individualsLoading,
  //   stats,
  // } = useIndividualsStats(
  //   locationSelect.value,
  //   {
  //     start: dateRangePicker.dateRange?.[0] || null,
  //     end: dateRangePicker.dateRange?.[1] || null,
  //   }
  // );

  // const { source, isLoading } = useBISource('individual_stats');
  // const [isIframeLoaded, setIsIframeLoaded] = useState(false);

  // const {
  //   isLoading: goalsLoading,
  //   stats: goalStats,
  // } = useIndividualsGoals(
  //   locationSelect.value,
  //   customerSelect.value,
  //   containerTypeSelect.value,
  //   {
  //     start: dateRangePicker.dateRange?.[0] || null,
  //     end: dateRangePicker.dateRange?.[1] || null,
  //   }
  // );

  // const goalStatsResults = useMemo(() => {
  //   const savedMinTop = goalStats[0] ? goalStats[0].saved_mins_tot : 1;
  //   return goalStats.map((item, index) => {
  //     let perc = 100;
  //     if (item.saved_mins_tot === 0) {
  //       perc = 0;
  //     } else if (index > 0) {
  //       perc = Math.round(item.saved_mins_tot * 100 / savedMinTop);
  //     }
  //     item.rel_perc = perc;
  //     return item;
  //   });
  // }, [goalStats]);

  const activeIndividuals = useMemo(() => {
    const list = (reportStats && reportStats.all_individuals) ? reportStats.all_individuals.slice() : [];
    // list.sort((a, b) => (a.full_name || '').localeCompare(b.full_name || '')); //sort alphabetically
    return list;
  }, [reportStats]);

  const filteredActiveIndividuals = useMemo(() => {
    searcher.setData(activeIndividuals);
    return searcher.search(searchVal);
  }, [activeIndividuals, searcher, searchVal]);

  const disabledDate = useMemo(() => {
    return (current) => {
      if (!current) return false;
      const unit = datePicker.mode === 'date' ? 'day' : datePicker.mode;
      return current > moment().endOf(unit);
    };
  }, [datePicker.mode]);

  return (

    <MainLayout>
      <IndividualStatsPageHeader
        title="Individuals Statistics"
        subTitle={
          <PeriodFilter selectedPeriod={datePicker.period} onChange={datePicker.setPeriod} />
        }
        icon="users"
      />

      <Row style={{ padding: '12px 24px' }}>
        <Col span={24}>
          <FilterBar
            title="Period Summary"
            titleStyles={{ fontWeight: 600, fontSize: '26px', lineHeight: 1.35, color: '#000' }}
            style={{ width: '100%' }}
            size="large"
          >
            <FilterBar.Slot align="left">
              <DatePicker
                mode={datePicker.mode}
                picker={datePicker.mode}
                value={datePicker.date}
                format={datePickerFormats[datePicker.period]}
                onChange={date => datePicker.setDate(date)}
                style={{ width: '260px' }}
                allowClear={false}
                disabledDate={disabledDate}
              />
            </FilterBar.Slot>
          </FilterBar>
        </Col>
      </Row>

      <Row style={{ padding: '24px' }}>
        <Col span={24}>
          <Stats data={reportStats} loading={reportStatsLoading} />
        </Col>
      </Row>

      <Row style={{ padding: '24px 24px 12px 24px' }}>
        <Col span={24}>
          <FilterBar
            title="Active Individuals"
            style={{ width: '100%', paddingBottom: '12px' }}
            size="large"
          >
            <FilterBar.Slot align="left">
              <Search
                placeholder="Search individual"
                value={searchVal}
                onChange={setSearchVal}
              />
            </FilterBar.Slot>
            {/* <FilterBar.Slot align="right">
              <Button
                type="outlined"
                icon={{
                  name: 'file-text',
                  size: 14,
                }}
                onClick={() => {
                  exportIndividualStats(filteredActiveIndividuals, dateRangePicker);
                }}
                disabled={filteredActiveIndividuals?.length === 0}
              >
                Generate Report
              </Button>
            </FilterBar.Slot> */}
          </FilterBar>
          <Table
            dataSource={filteredActiveIndividuals}
            loading={reportStatsLoading}
            rowKey={row => row.employee_id}
          >
            <Table.Column type="link" title="Individual" dataIndex="full_name" to={({ item }) => `/individuals/${item.employee_id}`} />
            <Table.Column type="number" title="Shifts Worked" dataIndex="working_shifts" align="right" precision={0} />
            <Table.Column type="number" title="Segments Worked" dataIndex="segments" align="right" precision={0} className="ant-table-column-sort" />
            <Table.Column type="number" title="FAST" dataIndex="tot_fast_segments" align="right" precision={0} className="ant-table-column-sort" />
            <Table.Column type="number" title="NORMAL" dataIndex="tot_normal_segments" align="right" precision={0} className="ant-table-column-sort" />
            <Table.Column type="number" title="SLOW" dataIndex="tot_slow_segments" align="right" precision={0} className="ant-table-column-sort" />
            <Table.Column type="number" title="Average CPH" dataIndex="avg_cph" align="right" precision={0} />
            <Table.Column type="duration" title="Time Saved" dataIndex="tot_saved_hrs" align="right" inHrs={true} withSecs={false} />
            <Table.Column type="duration" title="Time Lost" dataIndex="tot_lost_hrs" align="right" inHrs={true} withSecs={false} />
          </Table>
        </Col>
      </Row>

      {/* <Row style={{ padding: '24px' }}>
        <Col span={24}>
          <Row>
            <FilterBar
              title="Top 10 Individuals"
              titleStyles={{
                marginBottom: '0.5em',
                color: '#000',
                fontWeight: 600,
                fontSize: '24px',
                lineHeight: 1.35,
              }}
              style={{ width: '100%', paddingBottom: '12px' }}
              size="large"
            >
              <FilterBar.Slot align="left">
                <Dropdown
                  overlay={(
                    <Menu
                      selectable
                      selectedKeys={[sortByScore]}
                      onSelect={({ key }) => setSortByScore(key)}
                    >
                      {TOP_INDIVIDUAL_SORT_OPTIONS.map(item => (
                        <Menu.Item key={item.value}>{item.label}</Menu.Item>
                      ))}
                    </Menu>
                  )}
                  overlayStyle={{
                    minWidth: '120px'
                  }}
                  trigger="click"
                >
                  <a href="#/sort" className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                    <Space size="small">
                      {TOP_INDIVIDUAL_SORT_OPTIONS.find(o => o.value === sortByScore).label}
                      <Icon name="chevron-down" size={16} />
                    </Space>
                  </a>
                </Dropdown>
              </FilterBar.Slot>
            </FilterBar>
          </Row>
          <Row>
            <Table
              size="small"
              pagination={false}
              loading={goalsLoading}
              dataSource={goalStatsResults}
              rowKey={'code'}
              style={{ width: '100%' }}
            >
              <Table.Column type="link" title="Individual" dataIndex="code" prefix="# " to={({ item }) => `/individuals/${item.employee_id}`} />
              <Table.Column type="number" title="# shifts attended" dataIndex="tot_shifts" align="center" precision={0} />
              <Table.Column type="duration" title="Total time" dataIndex="total_time" align="center" withSecs={false} />
              <Table.Column type="duration" title="Saved time" dataIndex="saved_mins_tot" align="center" inMins={true} withSecs={false} />
              <Table.Column type="duration" title="Net savings" dataIndex="saved_mins_net" align="center" inMins={true} withSecs={false} />
              <Table.Column title="Saved time chart" width="40%" dataIndex="rel_perc" render={(relPerc) => {
                return (
                  <div style={{ width: `${relPerc}%`, overflow: 'hidden' }}>
                    <Progress
                      percent={100}
                      // strokeColor={'#FAAD14'}
                      strokeColor={colors.blue.normal}
                      strokeWidth={10}
                      // trailColor={colors.blue.normal}
                      showInfo={false}
                      style={{
                        borderRadius: 0,
                      }}
                    />
                  </div>
                );
              }} />
            </Table>
          </Row>
        </Col>
      </Row> */}

    </MainLayout>
  );
};

export default IndividualsStats;
